import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Warning, ShoppingCart } from "@phosphor-icons/react";

export default function LowStock() {
  const [items, setItems] = useState(null);
  const navigate = useNavigate();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    api.get("/dashboard/stats").then((r) => setItems(r.data.low_stock_items || [])).catch(() => setItems([]));
  }, []);

  return (
    <>
      <PageHeader title="Low Stock Alerts" subtitle={items ? `${items.length} item${items.length === 1 ? "" : "s"} at or below threshold` : "Loading…"} />
      <div className="p-4 sm:p-8">
        <div className="bg-white border border-zinc-300">
          <div className="flex items-center gap-2 px-6 py-4 border-b border-zinc-300 bg-zinc-50">
            <Warning size={18} weight="bold" className="text-[#DC2626]" />
            <h3 className="font-heading font-bold uppercase tracking-tight text-sm">Complete Low Stock List</h3>
          </div>
          {items === null ? (
            <p className="p-6 text-sm text-zinc-400">Loading…</p>
          ) : items.length === 0 ? (
            <p className="p-6 text-sm text-zinc-400" data-testid="low-stock-empty">All materials are healthy. Nothing to restock.</p>
          ) : (
            <div className="divide-y divide-zinc-200" data-testid="low-stock-full-list">
              {items.map((m) => (
                <div key={m.id} className="w-full flex items-center justify-between px-6 py-3 hover:bg-zinc-50 transition-colors duration-100" data-testid={`low-stock-full-${m.id}`}>
                  <button onClick={() => navigate(`/materials/${m.id}`)} className="text-left flex-1">
                    <p className="text-sm font-medium text-zinc-900">{m.name}</p>
                    <p className="text-xs text-zinc-500">Min {m.min_stock} {m.unit}{m.category ? ` · ${m.category}` : ""}</p>
                  </button>
                  <div className="flex items-center gap-4">
                    <div className="text-right">
                      <span className={`inline-block px-2 py-0.5 text-[10px] font-bold uppercase text-white ${m.status === "out" ? "bg-[#DC2626]" : "bg-[#EAB308]"}`}>
                        {m.status}
                      </span>
                      <p className="font-mono text-sm mt-1 tabular">{m.current_stock} {m.unit}</p>
                    </div>
                    <button
                      onClick={() => navigate("/purchase-orders", { state: { reorder: m } })}
                      data-testid={`reorder-full-${m.id}`}
                      title="Create purchase order"
                      className="flex items-center gap-1 text-[11px] font-bold uppercase tracking-wide text-white bg-primary hover:bg-[#C2410C] px-2 py-1.5 transition-colors duration-100"
                    >
                      <ShoppingCart size={13} weight="bold" /> Reorder
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
